<template>
	<div id="app">
        <loader class="global-loader" :loading="loading > 0"></loader>
        <main-header></main-header>
        <div class="main-content" :style="{'min-height': height + 'px'}">
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>
        <main-footer></main-footer>
        <alert v-model="errors" type="danger" icon="essentials/alerts/cancel"></alert>
        <alert v-model="messages" type="info" icon="essentials/alerts/info-circle"></alert>
        <alert v-model="warnings" type="warning" icon="essentials/alerts/exclamation-circle"></alert>
	</div>
</template>

<script>
    export default {
        computed: {
            height() {
                return this.$store.state.bodyHeight;
            },
            loading() {
                return this.$store.state.loading;
            },
            errors: {
                get() {
                    return this.$store.state.errors;
                },
                set(value) {
                    this.$store.state.errors = value;
                } 
            },
            messages: {
                get() {
                    return this.$store.state.messages;
                },
                set(value) {
                    this.$store.state.messages = value;
                }
            },
            warnings: {
                get() {
                    return this.$store.state.warnings;
                },
                set(value) {
                    this.$store.state.warnings = value;
                }
            }
        }
    }
</script>